import { render } from "./hospedaje2.vue?vue&type=template&id=d1a2383e&scoped=true"
import script from "./hospedaje2.vue?vue&type=script&lang=js"
export * from "./hospedaje2.vue?vue&type=script&lang=js"

import "./hospedaje2.vue?vue&type=style&index=0&id=d1a2383e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a2383e"]])

export default __exports__